// Sonar/common/schemas/collections/routines.js
import { z } from "zod";

const TriggerSchema = z.object({
    type: z.enum(["schedule", "event", "webhook"]).describe("The type of trigger that starts this routine."),
    config: z.record(z.any()).describe("Configuration specific to the trigger type. E.g., { cron: '0 * * * *' } for schedule, or { eventName: 'emailReceived' } for event.")
});

const AlertContextSchema = z.object({
    type: z.enum(["omnix_conversation", "in_app_notification"]),
    conversationId: z.string().describe("The unique conversation ID from Omnix, used as the agent's context ID."),
    contactId: z.string().describe("The Omnix contact ID of the user who set up the monitor."),
    channelType: z.string().optional().describe("The Omnix channel type (e.g., 'whatsapp', 'sms')."),
    channelIdentifier: z.string().optional().describe("The user's identifier on the channel (e.g., phone number)."),
    initialContext: z.record(z.any()).optional().describe("Other relevant data from the initial handoff."),
});

const RoutineSchema = z.object({
    _id: z.string().optional(),
    userId: z.string(),
    subscriptionId: z.string(),

    name: z.string().min(1, "Routine name is required."),
    
    // The core instruction for the agent. Replaces targetType, targetValue, and criteria.
    instructions: z.string().min(10, "Instructions must be at least 10 characters long."),
    
    // Flexible trigger mechanism
    trigger: TriggerSchema,
    
    // State management
    lastKnownState: z.string().optional().nullable().describe("A hash or summary of the routine's last known state."),
    lastRunAt: z.coerce.date().optional().nullable(),
    nextRunAt: z.coerce.date().optional().nullable(), // Primarily for 'schedule' triggers
    
    isActive: z.boolean().default(true),

    // The 'return address' for the alert
    alertContext: AlertContextSchema,

    createdAt: z.coerce.date().optional(),
    updatedAt: z.coerce.date().optional(),
});

export default RoutineSchema;